import { FeatureFlagDeclarations } from '../../feature-flags/feature-flag-declarations';
import { useFeatureFlag } from '../../feature-flags/hooks/use-feature-flag';

export const useOverwriteCustomerHoverDebounce = () => {
  return useFeatureFlag(FeatureFlagDeclarations.overwriteCustomerOverviewDebounce);
};
